import css from 'styled-jsx/css';
import { colors } from 'components/styles/variables';

export const useDropdownButtonStyles = {
  margin: 0,
  padding: 0,
  textTransform: 'none',
  boxSizing: 'unset',
  color: colors.BLACK,
  '&:hover': {
    backgroundColor: 'transparent',
  },
};

const styles = css`
  .dropdown-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: ${colors.WHITE};
    height: 44px;
    border-radius: 4px;
    margin: 0 16px 16px 16px;
    border: 1px solid ${colors.G2};
  }
  .dropdown-container:hover,
  .black-border {
    border-color: ${colors.BLACK};
  }
  .dropdownDisabled:hover {
    border-color: ${colors.G2};
  }
  .menu-item {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    cursor: pointer;
    width: 100%;
  }
`;
export default styles;
